// extracted by mini-css-extract-plugin
module.exports = {"container":"Bb","hero":"Cb","content":"Db","typeProd":"Eb","notTransparent":"Fb","sliderDots":"Gb","active":"Hb"};